import { useDispatch } from "react-redux";
import { ReactComponent as CopyIcon } from "../assets/img/copy-icon.svg";
import { showToast } from "../store/slices/toastSlice";

type CopyLinkButtonProps = {
  value: string;
  title?: string;
  successMessage?: string;
  errorMessage?: string;
  className?: string;
};

const CopyLinkButton = ({
  value,
  title = "Copy link",
  successMessage = "Link copied to clipboard",
  errorMessage = "Could not copy the link",
  className,
}: CopyLinkButtonProps) => {
  const dispatch = useDispatch();

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(value);
      dispatch(
        showToast({
          type: "success",
          title: "",
          message: successMessage,
          icon: "check_circle",
        }),
      );
    } catch (error) {
      console.error("Error while copying to the clipboard:", error);
      dispatch(
        showToast({
          type: "danger",
          title: "",
          message: errorMessage,
          icon: "error_outline",
        }),
      );
    }
  };

  return (
    <button
      type="button"
      className={`copy-link-btn${className ? ` ${className}` : ""}`}
      onClick={handleCopy}
      title={title}
      aria-label={title}
    >
      <CopyIcon />
    </button>
  );
};

export default CopyLinkButton;
